<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:WarehouseIds>
        <el-select
          multiple
          v-model="filters.WarehouseIds"
          filterable
          placeholder="请选择"
          @change="WarehouseChange"
        >
          <el-option
            v-for="item in warehouselist"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:FeeTypeNames>
        <el-select
          multiple
          v-model="filters.FeeTypeNames"
          filterable
          placeholder="请选择"
          @change="FeeTypeNameChange"
        >
          <el-option
            v-for="item in feeTypeList"
            :label="item.feeTypeName"
            :value="item.feeTypeName"
            :key="item.feeTypeName"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:FeeItemNames>
        <el-select
          multiple
          v-model="filters.FeeItemNames"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in feeItemList"
            :label="item.feeItemName"
            :value="item.feeItemName"
            :key="item.feeItemName"
          ></el-option>
        </el-select>
      </template>

      <template v-slot:StartStaus>
        <el-select
          multiple
          v-model="filters.StartStaus"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in startStausList"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
    </TwTable>

    <!-- 编辑 -->
    <el-dialog
      id="feeItemDialog"
      title="费用项维护"
      :visible.sync="addfeeItemVisible"
      width="50%"
      top="70px"
      style="text-align: center"
    >
      <el-form ref="form" :model="addForm" label-width="80px">
        <el-form-item label="仓库" prop="WarehouseId">
          <el-select
            v-model="addForm.WarehouseId"
            style="width: 100%"
            placeholder="请选择仓库"
            @change="ChangeWarehouse"
          >
            <el-option
              v-for="item in warehouselist"
              :label="item.warehouseName"
              :value="item.warehouseId"
              :key="item.warehouseId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="费用类型" prop="FeeTypeID">
          <el-select
            :disabled="disableFeeTypeID"
            v-model="addForm.FeeTypeID"
            style="width: 100%"
            placeholder="请选择费用类型"
            @change="ChangeFeeType"
          >
            <el-option
              v-for="item in selectFeeTypeList"
              :label="item.feeTypeName"
              :value="item.feeTypeID"
              :key="item.feeTypeID"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用项" prop="FeeItemID">
          <el-card class="box-card" style="text-align: left">
            <div
              v-for="(o, index) in this.addForm.CheckBoxList"
              :key="index"
              class="text item"
            >
              <el-checkbox
                :label="o.feeItemNameTimeDesc"
                v-model="o.isStart"
                :disabled="diablefeeItem"
              ></el-checkbox>
            </div>
          </el-card>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click.native="addfeeItemVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 30,
        businessCode: currentRow.feeItemID,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    ></LogDialog>
  </div>
</template>

<script>
import {
  GetWarehouseFeeItemList,
  GetFeeTypeList,
  GetFeeItemList,
  UpdateFeeItemStatus,
  GetFeeTypeAllList,
  GetFeeItemAllList,
  FeeItemSubmit,
} from "@/api/costManagement/warehouseCostConfigure.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import axios from "axios";
import { thereAre } from "util/util";
import LogDialog from "../../components/TwTable/components/logDialog";
export default {
  components: { LogDialog, TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "130",
          },
          {
            prop: "feeTypeName",
            label: "费用类型",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "feeItemName",
            label: "费用项",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "isStartDesc",
            label: "状态",
            minWidth: "150",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "feeDetailImportTimeDesc",
            label: "费用导入时间",
            align: "center",
            sortable: true,
            minWidth: "150",
          },

          {
            prop: "createTimeDesc",
            label: "创建时间",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "createUser",
            label: "创建用户",
            align: "center",
            minWidth: "100",
            sortable: true,
          },

          {
            prop: "updateTimeDesc",
            label: "修改时间",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "updateUser",
            label: "修改用户",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
        ],
      },
      checkList: [
        { feeItemID: 1, feeItemName: "存储费", isStart: true },
        { feeItemID: 2, feeItemName: "分拣费", isStart: true },
        { feeItemID: 3, feeItemName: "拍照费", isStart: true },
        { feeItemID: 4, feeItemName: "上架费", isStart: true },
        { feeItemID: 5, feeItemName: "卸货费", isStart: true },
      ],
      feeItemdata: [],
      FeeTypeList: [],
      selectFeeTypeList: [],
      addForm: [{ WarehouseId: 0, FeeTypeID: 0, CheckBoxList: [] }],
      disableFeeTypeID: true,
      diablefeeItem: true,
      warehouselist: [],
      feeTypeList: [],
      feeItemList: [],
      startStausList: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 0,
          label: "禁用",
        },
      ],
      addfeeItemVisible: false,
      WareHouse: [], //仓库
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "WarehouseIds",
            prop: "WarehouseIds",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouselist,
          },
          {
            type: "select",
            key: "FeeTypeNames",
            prop: "FeeTypeNames",
            label: "费用类型",
            multiple: true,
            slot: true,
            placeholder: "请选择费用类型",
            option: this.feeTypeList,
          },
          {
            type: "select",
            key: "FeeItemNames",
            prop: "FeeItemNames",
            label: "费用项",
            multiple: true,
            slot: true,
            placeholder: "请选择费用项",
            option: this.feeItemList,
          },
          {
            type: "select",
            key: "StartStaus",
            prop: "StartStaus",
            label: "启用状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.startStausList,
          },
        ],
        ///高级搜索配置
        moreSearch: [],
      },
      buttonList: [],

      //-------------
    };
  },
  methods: {
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },

    //查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    enableItem() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }

      let isStart = false;
      var ids = [];
      row.forEach((item) => {
        ids.push(item.feeItemID);
        if (item.isStart) {
          isStart = true;
        }
      });

      if (isStart) {
        this.$message({
          message: "请选择全部是禁用的的数据！",
          type: "error",
        });
        return;
      }

      UpdateFeeItemStatus({ feeItemIDs: ids, IsStart: 1 }).then((res) => {
        if (res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.initTable();
        } else {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        }
      });
    },
    disableItem() {
      let row = this.selectRows.rows;
      if (row == null || row.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });
        return;
      }

      let isStart = false;
      var ids = [];
      row.forEach((item) => {
        ids.push(item.feeItemID);
        if (!item.isStart) {
          isStart = true;
        }
      });

      if (isStart) {
        this.$message({
          message: "请选择全部是启用的数据！",
          type: "error",
        });
        return;
      }
      UpdateFeeItemStatus({ feeItemIDs: ids, IsStart: 0 }).then((res) => {
        if (res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.initTable();
        } else {
          this.$message({
            message: "操作失败",
            type: "error",
          });
        }
      });
    },
    edidFeeItem() {
      this.addForm = {};
      this.addfeeItemVisible = true;
    },
    ChangeWarehouse() {
      let para = {
        WarehouseIds: this.addForm.WarehouseId,
      };
      GetFeeTypeAllList(para).then((res) => {
        this.selectFeeTypeList = res.response;
        this.disableFeeTypeID = false;
      });
    },
    ChangeFeeType() {
      let para = {
        WarehouseIds: this.addForm.WarehouseId,
        FeeTypeId: this.addForm.FeeTypeID,
      };
      this.diablefeeItem = true;
      GetFeeItemAllList(para).then((res) => {
        this.$set(this.addForm, "CheckBoxList", res.response);

        this.diablefeeItem = false;
      });
    },
    WarehouseChange() {
      let para = {
        WarehouseIds: thereAre(this.filters.WarehouseIds),
        FeeTypeNames: thereAre(this.filters.FeeTypeNames),
        FeeItemNames: thereAre(this.filters.FeeItemNames),
        StartStaus: thereAre(this.filters.StartStaus),
      };
      GetFeeTypeList(para).then((res) => {
        this.feeTypeList = res.response;
      });
    },
    FeeTypeNameChange() {
      let para = {
        WarehouseIds: thereAre(this.filters.WarehouseIds),
        FeeTypeNames: thereAre(this.filters.FeeTypeNames),
        FeeItemNames: thereAre(this.filters.FeeItemNames),
        StartStaus: thereAre(this.filters.StartStaus),
      };
      GetFeeItemList(para).then((res) => {
        this.feeItemList = res.response;
      });
    },
    //查询列表
    initTable() {
      const { WarehouseIds, FeeTypeNames, FeeItemNames, StartStaus } =
        this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        WarehouseIds: thereAre(WarehouseIds),
        FeeTypeNames: thereAre(FeeTypeNames),
        FeeItemNames: thereAre(FeeItemNames),
        StartStaus: thereAre(StartStaus),
      };

      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      GetWarehouseFeeItemList(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },

    onSubmit() {
      FeeItemSubmit(this.addForm).then((res) => {
        if (res.success) {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.addfeeItemVisible = false;
          this.initTable();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },

    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    initDropList() {
      const { WarehouseIds, FeeTypeNames, FeeItemNames, StartStaus } =
        this.newfilters;
      let para = {
        WarehouseIds: thereAre(WarehouseIds),
        FeeTypeNames: thereAre(FeeTypeNames),
        FeeItemNames: thereAre(FeeItemNames),
        StartStaus: thereAre(StartStaus),
      };

      GetFeeTypeList(para).then((res) => {
        this.feeTypeList = res.response;
      });

      GetFeeItemList(para).then((res) => {
        this.feeItemList = res.response;
      });
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
    let user = JSON.parse(window.localStorage.user);

    this.warehouselist = user.warehouseList;

    this.initDropList();
  },
};
</script>
<style scoped lang="less">
</style>